import React from "react";
import PropTypes from "prop-types";

/**
 * Edit command cell component
 * @module
 * @param {func} edit - Edit function
 * @param {func} update - Update function
 * @param {func} abortChanges - Abort changes function
 * @param {func} editField - Edit field function
 */

export const editCommandCell = ({ edit, update, abortChanges, editField, disabled }) => {
  const EditCommandCell = (props) => {
    const { dataItem, tdProps } = props;
    const inEdit = dataItem[editField];
    const newClassName = `k-command-cell ${tdProps.className}`;

    if (!update && !inEdit) {
      return <td {...tdProps}></td>
    }

    return inEdit ? (
      <td  {...tdProps} className={newClassName}>
        <button
          className="k-button k-button-md k-button-rectangle k-button-solid k-button-solid-base k-grid-save-command"
          onClick={(e) => {
            e.preventDefault();
            update(dataItem);
          }}
        >
          Uložiť
        </button>
        <button
          className="k-button k-button-md k-button-rectangle k-button-solid k-button-solid-base k-grid-cancel-command"
          onClick={(e) => {
            e.preventDefault();
            abortChanges(dataItem);
          }}
        >
          Zrušiť
        </button>
      </td>
    ) : (
      <td {...tdProps} className={newClassName}>
        <button
          className="k-button k-button-md k-button-rectangle k-button-solid k-button-solid-primary k-grid-edit-command"
          onClick={(e) => {
            e.preventDefault();
            edit(dataItem);
          }}
          disabled={disabled}
        >
          Upraviť
        </button>
      </td>
    );
  };

  EditCommandCell.propTypes = {
    dataItem: PropTypes.object,
    style: PropTypes.object,
    onChange: PropTypes.func,
  };

  return EditCommandCell;
};
